// Redirect outside urls
export const MINN_POSTUR = 'https://minn.postur.is';
export const POSTSTOD = 'https://minn.postur.is/accounts/login';
export const GATTIN = 'https://gattin.postur.is/sap(====)/bc/bsp/sap/zthjv2/registration/Login.htm?langu=b';
